import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout'
import Empty from 'general/components/Empty'
import AppResource from 'general/constants/AppResource'
import { useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import { useMemo, useRef, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, Routes } from 'react-router-dom'
import styled from 'styled-components'
import Cart from '../Cart'
import Category from '../Category'
import Dashboard from '../Dashboard'
import HandleInvoice from '../HandleInvoice'
import HandleTicket from '../HandleTicket'
import Invoice from '../Invoice'
import SuccessFulOrder from '../Payment/components/succesFulOrder/'
import Payment from '../Payment/index.js'
import Process from '../Process'
import Registration from '../Registration'
import Report from '../Report'
import System from '../System'
import TaxMessage from '../TaxMessage'
import TemplateInvoice from '../TemplateInvoice'
import TemplateTicket from '../TemplateTicket'
import Ticket from '../Ticket'
import TaxDeduction from '../TaxDeduction'
import TaxDeductionDocuments from '../TaxDeductionDocuments'
import Taxpayer from '../Taxpayer'
import EnterpriseProfile from '../System/screens/EnterpriseProfile'
import Department from '../Department'
import Jobposition from '../Jobposition'
import ProtectedRoute from 'general/components/Routes/ProtectedRoute'
import UserManagement from '../System/screens/UserManagement'
import UserNoFunction from 'general/components/UserNoFunction'
import RegistrationAccountingDocument from '../RegistrationAccountingDocument'
import HandleDocument from '../HandleDocument'
import ListTaxMessageRegistrationAccountingDocuments from '../TaxMessage/screens/ListTaxMessageRegistrationAccountingDocuments'
import ListTaxMessageAccountingDocuments from '../TaxMessage/screens/ListTaxMessageAccountingDocuments'
import ErrorAnnouncementAccountingDocument from '../HandleInvoice/screens/ErrorAnnouncementAccountingDocument'
import SystemNotifycationModal from 'general/components/Modal/SystemNotifycationModal'
const EinvoiceContainer = styled.section({
  minHeight: '100%',
  maxHeight: '100%',
  maxWidth: '100%',
  overflowY: 'auto',
})

function InPutEInvoice() {
  // MARK: --- Props ---
  const { t } = useTranslation()
  const { pathname } = useRouter()
  const systemType = useAppSelector((s) => s.auth?.activeInvoice)
  const prefixPath = useMemo(
    () =>
      systemType?.invoice
        ? ''
        : systemType?.ticket
          ? 'tem-ve/'
          : systemType?.personalIncomeTax
            ? 'chung-tu-tncn/'
            : '',
    [systemType?.invoice, systemType?.ticket, systemType?.personalIncomeTax],
  )
  const user = useAppSelector((state) => state?.auth?.currentAccount)

  // show popup notice 2025
  const [isShowPopup, setShowPopup] = useState(true)
  const rootRef = useRef()
  const imgPath = AppResource.images.imgAnnouncements
  const [inforExportReportFileDetail, setInforExportReportFileDetail] =
    useState({ disable: false })
  return (
    <Routes>
      <Route path={prefixPath + 'hoa-don/*'} element={<Invoice />} />
    </Routes>
  )
}

export default InPutEInvoice
